import { backgroundCheckSystemPermissions } from '@/backend/features/permissions/backgroundCheckSystemPermissions';
import { configurationTransferPermissionsMap } from '@/backend/features/permissions/configurationTransferPermissionsMap';
import { dependenciesVersionsPermissionsMap } from '@/backend/features/permissions/dependenciesVersionsPermissionsMap';
import { alertsSystemPermissions } from '@juvare/alert-ui/backend/features/permissions';
import { announcementsOrgPermissions, announcementsSystemPermissions } from '@juvare/announcements/backend/features/permissions';
import { badgingOrgPermissions, badgingSystemPermissions } from '@juvare/badging/backend/features/permissions';
import { OrgPermissionDef, SystemPermissionDef } from '@juvare/contact-management/backend/features/permissions/shared';
import { credentialingSystemPermissions } from '@juvare/credentialing/backend/features/permissions';
import { documentLibraryOrgPermissions, documentLibrarySystemPermissions } from '@juvare/document-library/backend/features/permissions';
import { missionSystemPermissions } from '@juvare/missions/backend/features/permissions';
import { logiReportsOrgPermissions } from './logiReportsOrgPermissions';
import { logiReportsSystemPermissions } from './logiReportsSystemPermissions';

export const rmsSystemPermissions = {
    ...announcementsSystemPermissions,
    ...alertsSystemPermissions,
    ...backgroundCheckSystemPermissions,
    ...configurationTransferPermissionsMap,
    ...credentialingSystemPermissions,
    ...dependenciesVersionsPermissionsMap,
    ...documentLibrarySystemPermissions,
    ...missionSystemPermissions,
    ...logiReportsSystemPermissions,
    ...badgingSystemPermissions,
} as const satisfies SystemPermissionDef;

export const rmsOrgPermissions = {
    ...announcementsOrgPermissions,
    ...documentLibraryOrgPermissions,
    ...logiReportsOrgPermissions,
    ...badgingOrgPermissions,
} as const satisfies OrgPermissionDef;
